import { actionHelpers } from '../core';

export const getAccountsBalancesHistory = actionHelpers.createAction('GET_ACCOUNTS_BALANCES_HISTORY');
export const getAccountsBalancesHistorySuccess = actionHelpers.createAction('GET_ACCOUNTS_BALANCES_HISTORY_SUCCESS');
export const getAccountsBalancesHistoryFailure = actionHelpers.createAction('GET_ACCOUNTS_BALANCES_HISTORY_FAILURE');
